import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabBillItem from './diaglab-bill-item';
import DiaglabBillItemDetail from './diaglab-bill-item-detail';
import DiaglabBillItemUpdate from './diaglab-bill-item-update';
import DiaglabBillItemDeleteDialog from './diaglab-bill-item-delete-dialog';

const DiaglabBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabBillItem />} />
    <Route path="new" element={<DiaglabBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabBillItemDetail />} />
      <Route path="edit" element={<DiaglabBillItemUpdate />} />
      <Route path="delete" element={<DiaglabBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabBillItemRoutes;
